import React from 'react';
import Utility from '../utilities/utility';
import ShippingService from '../services/shipping';
import CountryService from '../services/country';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import AuthorizationCheck from '../auth/authorizationCheck';
import BranchService from '../services/branch';

class UpdateShipment extends React.Component {

    constructor(props) {
        super(props);

        this.shippingService = new ShippingService();
        this.countryService = new CountryService();
        this.branchService = new BranchService();

        const queryParams = new URLSearchParams(window.location.search);
        this.destinationCountryId = queryParams.get('countryId');

        this.state = {

            shipmentId: queryParams.get('shipmentId'),
            shipment: [],
            countries: [],
            shippingDate: new Date(),
            eta: new Date(),
            shipmentFeeList: [],
            shipmentFeeTypes: [],
            currentUserRole: '',
            branches: []
        }
    }

    componentDidMount() {

        this.fetchShipment();
        this.fetchCountries();
        this.shipmentFeeList();
        this.shipmentFeeTypes();
        this.branches();
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    fetchShipment = () => {

        try {

            this.shippingService.findShipment(this.state.shipmentId)
                .then(res => res.json())
                .then(shipment => {

                    this.setState({
                        shipment: shipment,
                        shippingDate: new Date(shipment.shippingDate),
                        eta: new Date(shipment.arrivalDate)
                    });
                })





        } catch (error) {

            console.log(error);
        }



    }

    updateShipment = async () => {

        try {

            let containerId = $('#containerId').val();
            let origin = $('#origin').val();
            let destination = $('#destination').val();
            let shippingDate = $('#shippingDate').val();
            let eta = $('#eta').val();
            let volume = $('#volume').val();
            let branchId = $('#branchId').val();

            const data = {
                'shipmentId': this.state.shipmentId,
                'containerId': containerId,
                'originCountryId': origin,
                'destinationCountryId': destination,
                'shippingDate': shippingDate,
                'arrivalDate': eta,
                'volume': volume,
                'branchId': branchId,

            };

            const response = await this.shippingService.updateShipment(data);

            if (response.ok) {

                $('.message-holder').html(

                    '<div class="alert alert-success shipment-alert">Chargement mis a jour</div>'
                );

                $('.shipment-alert').delay(3000).fadeOut('slow');
            }

        } catch (error) {

            $('.message-holder').html(

                '<div class="alert alert-danger shipment-alert">Le mis a jour a echoué</div>'
            );

            $('.shipment-alert').delay(3000).fadeOut('slow');
        }

    }

    fetchCountries = async () => {

        try {

            const response = await this.countryService.fetchCountries();

            this.setState({
                countries: await response.json()
            });

        } catch (error) {
            console.log(error)
        }

    }

    setShippingDate = (date) => {

        this.setState({ shippingDate: date })
    }

    setEta = (date) => {

        this.setState({ eta: date })
    }

    shipmentFeeList = async () => {


        try {

            const response = await this.shippingService.shipmentFeeList(this.state.shipmentId);

            this.setState({

                shipmentFeeList: await response.json()
            })

        } catch (error) {
            console.log(error);
        }

    }

    shipmentFeeTypes = async () => {


        try {

            const response = await this.shippingService.shipmentFeeTypeList();

            this.setState({

                shipmentFeeTypes: await response.json()
            })

        } catch (error) {
            console.log(error);
        }

    }


    addShipmentFee = async () => {

        let feeTypeId = $('#feeType').val();
        let source = $('#feeSource').val();
        let amount = $('#amount').val();

        try {

            if (Utility.isEmpty(source) || Utility.isEmpty(feeTypeId) || Utility.isEmpty(amount)) {

                console.log('Required details missing');

                return;
            }

            const response = await this.shippingService.addShipmentFee(this.state.shipmentId, feeTypeId, amount, source);

            let feeList = [...this.state.shipmentFeeList];

            feeList.unshift(await response.json());

            this.setState({

                shipmentFeeList: feeList
            })

        } catch (error) {
            console.log(error);
        }

    }

    branches = async () => {

        try {

            const response = await this.branchService.branchList(this.destinationCountryId);

            this.setState({

                branches: await response.json()
            })
        } catch (error) {

            console.log(error);
        }


    }

    render() {



        if (Utility.isEmpty(this.state.shipment)) {

            return ('Not found');
        }

        const shipment = this.state.shipment;

        const branches = this.state.branches;

        return (
            <div className="container update-shipment-wrapper mt-4">


                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />


                <h2 className="mb-3 text-center">Mis a jour du Chargement </h2>


                <div className="form-wrapper">



                    <div className="message-holder"></div>

                    <div className='row'>

                        <div className='col-md-6'>

                            <h3 className='text-center'>Chargement</h3>

                            <div className="form-group">
                                <label className="label">Origin</label>
                                <select className="form-control" id="origin">
                                    {this.state.countries.length > 0 && this.state.countries.map(country =>

                                        this.state.shipment.originCountryId == country.countryId ?
                                            <option key={country.countryId} value={country.countryId} selected={true}>{country.name}</option> :
                                            <option key={country.countryId} value={country.countryId}>{country.name}</option>

                                    )}
                                </select>
                            </div>


                            <div className="form-group">
                                <label className="label">Destination </label>

                                <select className="form-control" id="destination">
                                    {this.state.countries.length > 0 && this.state.countries.map(country =>

                                        this.state.shipment.destinationCountryId == country.countryId ?
                                            <option key={country.countryId} value={country.countryId} selected={true}>{country.name}</option> :
                                            <option key={country.countryId} value={country.countryId}>{country.name}</option>

                                    )}
                                </select>

                            </div>


                            <div className='form-group'>
                                <label className="label">Branche</label>
                                <select className='form-control' id='branchId'>
                                    <option></option>

                                    {branches.length > 0 && branches.map(branch =>

                                        shipment.branchId === branch.branchId ?<option value={branch.branchId} selected={true}> {branch.name} </option> : <option value={branch.branchId}> {branch.name} </option>

                                    )}

                                </select>



                            </div>

                            <div className="form-group">
                                <label className="label">Numero de conteneur </label>
                                <input className="form-control" id="containerId" placeholder="Numero de Conteneur" defaultValue={shipment.containerId} />
                            </div>

                            <div className="form-group">
                                <label className="label">Volume en CBM</label>
                                <input className="form-control" id="volume" placeholder="CBM" defaultValue={shipment.volume} />
                            </div>

                            <div className="form-group">
                                <DatePicker id="shippingDate" dateFormat="yyyy-MM-dd" selected={this.state.shippingDate} placeholderText="Date d'embarquement" className="form-control" onChange={this.setShippingDate} />
                            </div>

                            <div className="form-group">
                                <DatePicker id="eta" dateFormat="yyyy-MM-dd" selected={this.state.eta} placeholderText="Date d'arrivée" className="form-control" onChange={this.setEta} />
                            </div>

                            <div className="form-group">
                                <button className="btn btn-primary full-width" onClick={() => this.updateShipment()}>Enregistrer</button>
                            </div>


                        </div>

                        <div className='col-md-6 border-left'>
                            <div className='shipmentFeeForm'>

                                <h3 className='text-center'>Frais</h3>

                                <div className="form-group">
                                    <label className="label">Source du Frais</label>
                                    <select className="form-control" id="feeSource">

                                        <option></option>
                                        <option value="SUPPLIER">FOURNISSEUR</option>
                                        <option value="CUSTOMER">CLIENT</option>


                                    </select>
                                </div>

                                <div className="form-group">
                                    <label className="label">Type de frais</label>
                                    <select className="form-control" id="feeType">

                                        <option></option>

                                        {this.state.shipmentFeeTypes.length > 0 && this.state.shipmentFeeTypes.map(shipmentFeeType =>

                                            <option key={shipmentFeeType.feeTypeId} value={shipmentFeeType.feeTypeId}>{shipmentFeeType.name}</option>

                                        )}

                                    </select>
                                </div>

                                <div className="form-group">
                                    <input className='form-control' id='amount' placeholder='Montant' />
                                </div>

                                <div className="form-group">
                                    <button className="btn btn-primary full-width" onClick={() => this.addShipmentFee()}>Ajoute Frais</button>
                                </div>

                            </div>

                            <div>
                                {this.state.shipmentFeeList.length > 0 && this.state.shipmentFeeList.map(shipmentFee =>

                                    <div className='row'>
                                        <div className='col'>{shipmentFee.feeType}</div>
                                        <div className='col'>{shipmentFee.amount}</div>
                                    </div>

                                )}
                            </div>


                        </div>



                    </div>

                </div>






            </div>
        );
    }


}

export default UpdateShipment;